/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'orderservicer': {
    width: 17,
    height: 17,
    viewBox: '0 0 17 17',
    data: '<path pid="0" d="M15.414.5c.51 0 .935.388.993.884l.007.116v14c0 .51-.388.935-.884.993l-.116.007h-14c-.51 0-.935-.388-.993-.884L.414 15.5v-14c0-.51.388-.935.884-.993L1.414.5h14zm-.5 1.5h-13v13h13V2zm-3.25 7.5a.75.75 0 110 1.5h-6.5a.75.75 0 110-1.5h6.5zm-2-4a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
